<template>
  <div v-if="project != null">
    <h1>ANTECEDENTES MEDICOS</h1>
    <table class="table" >
      <thead>
      </thead>
      <tbody>
        <tr>
          <td width="40%;">
            <input type="checkbox" class="form-check-input" id="has_medical_antecedent" v-model="project.has_medical_antecedent">
            <label class="form-check-label" for="exampleCheck1">¿Tiene algún antecedente médico (Musculoesquelético) o psiquiátrico?</label>
          </td>
          <template v-if="project.has_medical_antecedent">            
            <td width="10%;">
              ¿ Cuales ?
            </td>          
            <td>
              <input type="text" name="medical_antecedent_observations" class="form-control" id="medical_antecedent_observations" placeholder="" v-model="project.medical_antecedent_observations"/>
            </td>
          </template>
        </tr>
        <tr>
          <td>
            <input type="checkbox" class="form-check-input" id="has_incapacitate_disease" v-model="project.has_incapacitate_disease">
            <label class="form-check-label" for="exampleCheck1">¿Ha sido incapacitado por enfermedad significativa?</label>
          </td>
          <template v-if="project.has_incapacitate_disease">            
            <td width="10%;">
              ¿ Cuales ?
            </td>          
            <td>
              <input type="text" class="form-control" id="incapacitate_disease_observations" placeholder="" v-model="project.incapacitate_disease_observations"/>
            </td>
          </template>
        </tr>
        <tr>
          <td>
            <input type="checkbox" class="form-check-input" id="has_medical_treatment" v-model="project.has_medical_treatment">
            <label class="form-check-label" for="exampleCheck1">¿Se encuentra actualmente en tratamiento médico?</label>
          </td>
          <template v-if="project.has_medical_treatment">            
            <td width="10%;">
              ¿ Cuales ?
            </td>          
            <td>
              <input type="text" class="form-control" id="medical_treatment_observations" placeholder="" v-model="project.medical_treatment_observations"/>
            </td>
          </template>
        </tr>
        <tr>
          <td>
            <input type="checkbox" class="form-check-input" id="has_accidents" v-model="project.has_accidents">
            <label class="form-check-label" for="exampleCheck1">Accidentes de tránsito, laborales y otros</label>
          </td>
          <template v-if="project.has_accidents">            
            <td width="10%;">
              ¿ Cuales ?
            </td>          
            <td>
              <input type="text" class="form-control" id="accidents_observations" placeholder="" v-model="project.accidents_observations"/>
            </td>
          </template>
        </tr>                        
      </tbody>
    </table>
    <b-button variant="primary" @click.prevent="save">Guardar</b-button>
		<div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>    
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'
import SelectLocal from './../../own/select-local.vue'

export default {
  name: 'MedicalHistory',
  props: ['project_id', 'assignment_id'],  
  computed: {
    ...mapGetters(['projectId', 'assignmentId', 'project', 'assignment', 'selects'])
  },  
  data() {
    return {
			message: '',
			typeMessage: ''
    }
  },
  components: {
    'select-local': SelectLocal,
  },  
  methods: {
    ...mapMutations(['changeProjectId', 'changeAssignmentId', 'changeProject', 'changeAssignment', 'changeSelects']),
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    getInformationWork() {
      console.log("3***")
			axios.get(`/information_work.json?project_id=${this.project_id}&assignment_id=${this.assignment_id}`).then(res=>{
				if(res.status == 200){
          this.changeProjectId(this.project_id)
          this.changeAssignmentId(this.assignment_id)
          this.changeProject(res.data.project)
          this.changeAssignment(res.data.assignment)
          this.changeSelects(res.data.selects)
				}
			})
    },
    save(){
      this.defaultAxios()
      let project = this.project
      delete project.family_compositions
      delete project.family_references
      delete project.family_sicks
      delete project.working_condition
      delete project.laboral_references
      delete project.family_interviews
			axios.put(`/update_information_personal`, { project: project }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Proceso actualizado', 'alert-success')
				}else{
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('El registro no se pudo actualizar', 'alert-danger')
      })
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},        
  },
  created () {

  },
  watch: {
    data(newValue, oldValue) {
      
    }
  },
  filters: {
    fnName: function(value) {
      return value;
    }
  }
}
</script>

<style scoped>

</style>